import { observable, computed, action } from 'mobx'

import BaseListStore from 'stores/base/BaseListStore'

import Project, { IProjectCreatePayload } from './Project'

class ProjectStore extends BaseListStore<Project, IProjectCreatePayload> {
  @observable activeProjectId: string | null

  constructor() {
    super(Project, { idbTableName: 'projects' })

    this.activeProjectId = null
  }

  @computed
  get activeProject(): Project | null {
    const projectId = this.activeProjectId
    if (!projectId) {
      return null
    }
    return this.get(projectId)
  }

  @action
  switch(projectId: string) {
    this.activeProjectId = projectId
  }
}

export default new ProjectStore()
